import React, { Component } from 'react';
import styles from './PricingHeader.module.scss';

export default class PricingHeader extends Component {
  render() {
    const { creative } = this.props;

    return (
      <div className={'container ' + styles.container}>
        <h1 className={styles.title}>
          {creative ? 'Upgrade to Pro' : 'Pricing'}
        </h1>
        {creative && <h3>Find more job leads and win more work</h3>}
      </div>
    );
  }
}
